export default {
  init() {

  },
  finalize() {
    const params = new URLSearchParams(window.location.search);

    if (params.get('newsletter-signup')) {
      window.scrollTo(0, $('.footer-wrap').offset().top);
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/newsletterSignup.js